import React from "react"
import styles from "./formSection.module.css"

const FormSection = ({ title, description, action, children, className = "" }) => (
    <section className={`${styles.section} ${className}`.trim()}>
        <header className={styles.header}>
            <div>
                <h4>{title}</h4>
                {description && <p>{description}</p>}
            </div>
            {action && <div className={styles.action}>{action}</div>}
        </header>
        <div className={styles.body}>{children}</div>
    </section>
)

export default FormSection
